const getErrorByCode = (code = 13000, phone = "(727) 353-7456") => {
  let error = "Whoops! Something went wrong.";
  let solution = "Is there a different payment method you could try? ";
  let support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
  switch (code) {
    case 13000:
      error = "Whoops! Something went wrong.";
      solution = "Please re-enter your card information and try again.";
      support = "If the problem persists, you can try using an alternate payment method or reach out to us directly at"
      break;
    case 13001:
      error = "Whoops! Something went wrong.";
      solution = "Please re-enter your card information and try again.";
      support = "If the problem persists, you can try using an alternate payment method or reach out to us directly at"
      break;
    case 13002:
      error = "This transaction has been declined due to suspicious activity.";
      support = "Fraud filters are triggered automatically. We recommend that you get in touch with your bank immediately if you believe you've received this message by mistake. If you have any questions, we encourage you to call us at "
      break;
    case 13004:
      error = "This transaction has been declined due to suspicious activity.";
      support = "Fraud filters are triggered automatically. We recommend that you get in touch with your bank immediately if you believe you've received this message by mistake. If you have any questions, we encourage you to call us at "
      break;
    case 13006:
      error = "This transaction is being held for review and can't be processed right now.";
      break;
    case 13007:
      error = "Hmm ... We're seeing insufficient funds.";
      break;
    case 13008:
      error = "Hmm ... We're seeing insufficient funds.";
      break;
    case 13009:
      error = "This card has been reported lost or stolen.";
      break;
    case 13010:
      error = "The account holder has been reported deceased.";
      break;
    case 13011:
      error = "Hmm ... looks like this account has been closed.";
      break;
    case 13012:
      error = "Hmm ... looks like this account has been closed.";
      break;
    case 13013:
      error = "Hmm ... looks like this account has exceeded the daily withdrawal limit.";
      break;
    case 13014:
      error = "Your financial institution isn't allowing transactions on this account right now.";
      break;
    case 13015:
      error = "Hmm ... We're seeing an ACH error. ";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 13016:
      error = "Hmm ... We're seeing an ACH error. ";
      break;
    case 13017:
      error = "The account holder has stopped payment on this transaction.";
      break;
    case 13018:
      error = "Hmm ... it looks like this transaction was declined.";
      break;
    case 13019:
      error = "Hmm ... it looks like this transaction was declined.";
      break;
    case 13020:
      error = "Hmm ... it looks like credit card entered is currently restricted by PayPal.";
      break;
    case 13021:
      error = "Hmm ... we're seeing an ACH \"unauthorized debit\" error. ";
      solution = "You need a new authorization number before resubmitting payment. Alternatively, you can try an different payment method.";
      break;
    case 13022:
      error = "Hmm ... It looks like this bank doesn't support ACH transactions. ";
      break;
    case 13023:
      error = "Hmm ... looks like debits aren't allowed with this bank account.";
      break;
    case 14005:
      error = "Whoops ... Invalid CVV";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 14006:
      error = "Whoops ... Invalid expiration";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 14007:
      error = "Whoops ... this card seems to have expired";
      solution = "Is there a different payment method you could try? .";
      support = "We're here to help: "
      break;
    case 14008:
      error = "Whoops ... Invalid CVV";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 14009:
      error = "This looks like it might be a duplicate transaction.";
      solution = "If you're sure this transaction isn't a mistake, please wait a few minutes and try again. Alternatively, you can select a different payment method. ";
      support = "We're here to help: "
      break;
    case 14010:
      error = "Whoops ... Invalid state or province";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 14011:
      error = "Whoops ... Invalid city";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 14012:
      error = "Whoops ... Invalid address";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14013:
      error = "Uh oh ... We couldn't verify your address.";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14014:
      error = "We've encountered an error.";
      solution = "Is there a different payment method you could try? ";
      support = "Alternatively, we might be able to troubleshoot this if you give us a call: "
      break;
    case 14015:
      error = "We've encountered an error.";
      solution = "Is there a different payment method you could try? ";
      support = "Alternatively, we might be able to troubleshoot this if you give us a call: "
      break;
    case 14016:
      error = "Whoops ... Invalid account number";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 14017:
      error = "Whoops ... Invalid routing number";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 14018:
      error = "Verification failed";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14019:
      error = "We can't charge this type of card.";
      solution = "Is there a different payment method you could try? ";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14020:
      error = "Whoops ... We're missing some required information.";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14021:
      error = "We can't charge this type of account.";
      solution = "Is there a different payment method you could try? ";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14022:
      error = "Uh oh ... We couldn't verify your address.";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14023:
      error = "Uh oh ... We couldn't verify your address.";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14024:
      error = "Uh oh ... We couldn't verify your address.";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14025:
      error = "Uh oh ... We couldn't verify your address.";
      solution = "Please re-enter your card information or use an alternate payment method.";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14026:
      error = "We can't use this type of currency.";
      solution = "Is there a different payment method you could try? ";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14027:
      error = "Hmm ... it looks like we've encountered an ACH error.";
      solution = "Is there a different payment method you could try? ";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14028:
      error = "This credit card number is reserved and may not be used for payments";
      solution = "Is there a different payment method you could try? ";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14029:
      error = "Hmm ... it looks like we've encountered an ACH error.";
      solution = "Is there a different payment method you could try? ";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14030:
      error = "Hmm ... it looks like we've encountered an ACH error.";
      solution = "Is there a different payment method you could try? ";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 14031:
      error = "Hmm ... it looks like your bank needs more information to approve this transaction. ";
      solution = "Please contact your credit card issuer to resolve this matter. Alternatively, is there a different payment method you could try? ";
      support = "If you have any questions or believe you're receiving this message by mistake, we encourage you to call us at "
      break;
    case 15000:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 15001:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 15002:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 15003:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 15004:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 15005:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 15006:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please wait a few moments and try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 15007:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please wait a few moments and try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 15008:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please wait a few moments and try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 15009:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please wait a few moments and try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 15010:
      error = "Sorry ... The payment processor encountered an error.";
      solution = "Please wait a few moments and try again or use an alternate payment method.";
      support = "We're here to help: "
      break;
    case 16000:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    case 16001:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    case 16002:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    case 16003:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    case 16004:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    case 16005:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    case 16006:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    case 16007:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    case 16008:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    case 16009:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    case 16010:
      error = "Uh oh ... We've encountered an authentication error.";
      solution = "We apologize for the inconvenience. Please try again.";
      support = "If the error persists, don't hesitate to reach out: "
      break;
    default:
      error = "Whoops! Something went wrong.";
      solution = "Please re-enter your card information and try again.";
      support = "If the problem persists, you can try using an alternate payment method or reach out to us directly at"
  }
  return error + " " + solution + " " + support + " " + phone + ".";
};

export default getErrorByCode;
